import { ChangeEvent } from 'react';

import { MenuItem, TextField } from '@material-ui/core';

import { useAggregatedMeasurement } from './context';

export type SelectProps = {
  label: string;
  helperText?: string;
  required?: boolean;
  disabledOptions?: string[];
  emptyLabel?: string;
};

export const Select = ({
  label,
  helperText,
  required,
  disabledOptions = [],
  emptyLabel = 'The number of fact rows',
}: SelectProps) => {
  const { measurement, factTable, measures, onMeasurementChange } =
    useAggregatedMeasurement();

  const handleChange = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    onMeasurementChange(e.target.value);
  };

  return (
    <TextField
      required={required}
      label={label}
      name="measurement"
      margin="dense"
      fullWidth
      variant="outlined"
      onChange={handleChange}
      value={measurement?.name ?? ''}
      disabled={!factTable}
      select
      helperText={helperText}
      SelectProps={{ displayEmpty: !!emptyLabel }}
      InputLabelProps={{ shrink: true }}
    >
      <MenuItem value="" divider disabled={!emptyLabel}>
        <em>{emptyLabel}</em>
      </MenuItem>
      {measures.map(option => (
        <MenuItem
          value={option.column.name}
          key={option.column.name}
          disabled={disabledOptions.includes(option.column.name)}
        >
          {option.column.name}
        </MenuItem>
      ))}
    </TextField>
  );
};
